angular.module('bribac.views.addRuleSet', [
  'ngRoute',
  'bribac.values',
  'bribac.entities.ruleSetFactory',
  'bribac.services.routeAuth',
  'bribac.components.ruleSetEditor',
  'bribac.components.ruleSetDetails'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/add/settings', {
      templateUrl: 'add-rule-set-view.html',
      controller: 'AddRuleSetViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('AddRuleSetViewCtrl', function(
    $location,
    ruleSetFactory,
    state
  ) {

    var $ctrl = this

    $ctrl.savedEntities = []

    function setNewEntity() {
      $ctrl.entity = ruleSetFactory({
        template: true,
        bacLimit: {unit: state.currentAgent.organization.bacUnit}
      })
    }

    $ctrl.successCallback = function(data) {
      $ctrl.savedEntities.push(data)
      setNewEntity()
    }

    // Init

    setNewEntity()

  })
